<template>
    <div>
        <v-list-item class="package-list-item phonebg" v-ripple="{class: 'ripple--color'}" @click="openAction">
            <v-list-item-avatar width="65" height="45" rounded>
                <v-img v-if="pkg.image_url" cover :src="pkg.image_url"></v-img>
                <div v-else class="d-flex align-center justify-center" style="width: 100%; height: 100%; background: #00897B">
                    <v-icon small color="white">mdi-package-variant-closed</v-icon>
                </div>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title>{{ pkg.name }}</v-list-item-title>
                <v-list-item-subtitle>
                    <span v-if="pkg.subscribed && pkg.renewal_required" class="orange--text text--darken-2">مطلوب تجديد</span>
                    <span v-else-if="pkg.subscribed" class="success--text">مشترك</span>
                    <b v-else-if="pkg.price != null && platform !== 'ios'" class="primary--text">{{ moneyFormat(pkg.price, true) }}</b>
                    <span v-else>باقة اشتراك</span>
                    <span v-if="pkg.current_month"> | {{ pkg.current_month.name }}</span>
                </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-icon v-if="pkg.renewal_required" class="my-auto">
                <v-icon>{{ pkg.subscribed && !pkg.renewal_required ? 'mdi-check' : 'mdi-chevron-left' }}</v-icon>
            </v-list-item-icon>
        </v-list-item>

        <package-dialog v-model="dialog" :pkg="pkg" :mode="dialogMode" @done="onDone" />
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import PackageDialog from '@/components/custom/package-dialog'

export default {
    props: {
        pkg: { type: Object, required: true },
    },
    components: { PackageDialog },
    data() {
        return {
            dialog: false,
            dialogMode: 'subscribe',
        }
    },
    computed: {
        ...GlobalComputed,
    },
    methods: {
        ...GlobalMethods,
        openAction() {
            if (this.pkg.subscribed && !this.pkg.renewal_required) {
                this.showMsg('أنت مشترك بالفعل في الباقة', 'grey lighten-3')
                return
            }
            this.dialogMode = this.pkg.subscribed && this.pkg.renewal_required ? 'renew' : 'subscribe'
            this.dialog = true
        },
        onDone() {
            this.$emit('updated')
        },
    },
}
</script>
